import React, { useState, useRef, useCallback } from 'react';
import algoliasearch from 'algoliasearch/lite';
import {
  InstantSearch,
  Hits,
  connectStateResults,
  PoweredBy,
} from 'react-instantsearch-dom';
import AlgoliaInput from './Input';
import GraduateItem, { Wrapper as GraduateWrapper } from '../Item';
import { resolveGraduateProps, boolFilters } from '../utils';
import styled from 'styled-components';
import Card from '../../Card';
import BoolFilters from './BoolFilters';
import AlgoliaPagination from './Pagination';
import Text from '../../Text';
import Spinner from '../../Spinner';
import { Flex } from 'rebass';
import { fontSize, color } from 'styled-system';

const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_API_KEY,
);

const StyledHits = styled(Hits)``;

const List = styled(Card)`
  overflow: hidden;
  .ais-Hits-item:last-child {
    ${GraduateWrapper} {
      border-bottom: 0;
    }
  }
`;

const SyledPoweredBy = styled(PoweredBy).attrs({
  color: 'secondary',
  fontSize: 0,
})`
  ${fontSize}
  ${color}
  filter: saturate(0);
  opacity: 0.5;
  display: flex;
  align-items: center;
  flex-direction: column;
  svg {
    width: 80px;
  }
`;

const Results = connectStateResults(({ searchResults, children }) => {
  // has results
  if (searchResults && searchResults?.nbHits !== 0) {
    return children;
  }
  if (searchResults?.query && searchResults?.nbHits === 0) {
    return (
      <Text textAlign="center" my={3} fontSize={3} variant="tertiary">
        No practitioners were found for {searchResults?.query}
      </Text>
    );
  }
  return <Spinner mx="auto" my={3} display="block" />;
});

const GraduatesAlgolia = () => {
  const [_boolFilters, onChangeBoolFilters] = useState({
    isActive: false,
    isFeatured: false,
    isIntegrationPractitioner: false,
  });
  const topRef = useRef();
  const scrollToTop = useCallback(() => {
    if (typeof window !== 'undefined' && topRef?.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [topRef]);
  return (
    <InstantSearch
      indexName={process.env.GATSBY_ALGOLIA_PRACTITIONERS_INDEX_NAME}
      searchClient={searchClient}
    >
      <Flex width={1} alignItems="center" style={{ position: 'relative' }}>
        {/* compensate for header height */}
        <div ref={topRef} style={{ position: 'absolute', top: -100 }} />
        <AlgoliaInput
          flex={1}
          mr={3}
          placeholder="Search by name or location (city, state/province or country)"
        />
        <SyledPoweredBy />
      </Flex>
      <BoolFilters
        boolFilters={boolFilters}
        _boolFilters={_boolFilters}
        onChangeBoolFilters={onChangeBoolFilters}
        my={2}
      />
      <Results>
        <List mb={3}>
          <StyledHits
            hitComponent={({ hit }) => (
              <GraduateItem {...resolveGraduateProps(hit)} />
            )}
          />
        </List>
      </Results>
      <AlgoliaPagination onPageChange={scrollToTop} />
    </InstantSearch>
  );
};

export default GraduatesAlgolia;
